/**
 * Created by Jerker Nord on 2024-02-23.
 */
import {LonerBigWildSymbol} from "./LonerBigWildSymbol";
import {LonerStatics} from "../../../../LonerStatics";

export class LonerBigWildSymbol2x2 extends LonerBigWildSymbol {

    constructor() {
        super();
        this._bigSymContainer.position.x = 0 - (LonerStatics.symbolWidth / 2);
        this._bigSymContainer.position.y = 0 - (LonerStatics.symbolHeight / 2);
    }
}